import { css } from 'lit'

const inputGlobalStyles = css`
  input,
  textarea {
    --input-side-margin: 12px;
    display: block;
    border-radius: var(--small-border-radius);
    border: var(--small-border);
    padding: 8px;
    font-size: 16px;
    min-width: 250px;
    margin: 16px 0px;
  }
  input:focus {
    outline: none;
  }
  @media only screen and (max-width: 1024px) {
  }

  @media only screen and (max-width: 768px) {
  }

  @media only screen and (max-width: 480px) {
  }
`

export default inputGlobalStyles
